import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { employeeMemberships } from './employeeMemberships'

export const teamsLedByEmployee = (teams: Teams, memberships: Memberships, employeeId: string) => {
  return employeeMemberships(memberships, employeeId)
    .filter((membership) => {
      return membership.attributes.employee_id === employeeId && membership.attributes.lead
    })
    .map((membership) => teams.get(membership.attributes.team_id))
    .filter(Boolean)
}
